import { connect } from 'react-redux';
import { Link } from 'react-router';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/cart/continueShopping.scss';

const makeUrl = props => {
  const {
    landingPage: {
      isLoaded: isLandingLoaded,
      brandId,
      pageInfo: {
        pageType
      } = {},
      pageName
    },
    product: {
      detail: isPDPLoaded,
      seoProductUrl
    },
    products: {
      totalProductCount: isSearchLoaded,
      executedSearchUrl
    }
  } = props;

  // has search been visited?
  if (isSearchLoaded) {
    return executedSearchUrl;
  }

  // has landing page been visited, and are those major landing or brand page?
  if (isLandingLoaded && (pageType === 'Landing' || pageType === 'Brand')) {
    if (pageName) {
      return `/c/${pageName}`;
    }

    // if its not a major brand landing page, take you back to that generic brand page
    if (brandId) {
      return `/brand/${brandId}`;
    }
  }

  // has product page been loaded?
  if (isPDPLoaded) {
    return seoProductUrl;
  }

  return '/';
};

export const ContinueShopping = props => {
  const { testId } = useMartyContext();

  return (
    <Link
      to={makeUrl(props)}
      className={css.continue}
      data-test-id={testId('continueShopping')}>
      Continue Shopping
    </Link>
  );
};

export const mapStateToProps = state => {
  const {
    landingPage,
    product,
    products
  } = state;

  return {
    landingPage,
    product,
    products
  };
};

export default connect(mapStateToProps, {})(ContinueShopping);
